import { useTranslation } from 'react-i18next';

export default function AllianceIntro() {
  const { t } = useTranslation('supplierNetwork');

  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div>
            {/* Left: narrative */}
            <div>
              <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
                {t('intro.label')}
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 leading-tight mb-4">
                {t('intro.title')}
              </h2>
              <p className="text-sm md:text-base text-ink-400 mb-6 leading-relaxed">
                {t('intro.subtitle')}
              </p>

              <h3 className="text-lg md:text-xl font-bold text-ink-700 mb-3">
                {t('intro.networkTitle')}
              </h3>
              <p className="text-sm md:text-base text-ink-500 leading-relaxed">
                {t('intro.networkDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}